module.exports = __webpack_public_path__ + "img/bathrooms-green.2bc445b3.svg";